import * as React from 'react';

const ArrowRight16 = ({ title, titleId, ...props }) => /* @__PURE__ */ React.createElement("svg", { fill: "none", viewBox: "0 0 16 16", width: 16, height: 16, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement(
  "path",
  {
    fill: "currentColor",
    d: "M1 7.949c0 .432.345.783.77.783h10.738l-4.51 4.958a.79.79 0 0 0 .048 1.107.76.76 0 0 0 1.074-.042l5.6-6.038a1.057 1.057 0 0 0 0-1.433l-5.602-6.04a.755.755 0 0 0-1.07-.042.785.785 0 0 0-.042 1.107l4.502 4.856H1.77a.777.777 0 0 0-.771.784Z"
  }
));
ArrowRight16.Size = 16;
ArrowRight16.Title = "ArrowRight";

export { ArrowRight16 as default };
